<template>
    <!-- Filtro los items cuando seleccione el icono correspondiente -->
    <v-speed-dial v-model="fab" slide-y-reverse-transition direction="bottom">
        <template v-slot:activator>
            <v-btn color="dark" light fab small>
                <v-icon v-if="fab">
                    mdi-pencil
                </v-icon>
                <v-icon v-else>
                    mdi-pencil-outline
                </v-icon>
            </v-btn>
        </template>
        <router-link style="text-decoration: none" to="/ListarDomicilio">
            <v-btn fab small light @click="filtrarDomicilios">
                <v-icon color="red">mdi-map-marker-plus-outline</v-icon>
            </v-btn>
        </router-link>
        <router-link style="text-decoration: none" to="/ListarTelefono">
            <v-btn fab light small @click="filtrarTelefono">
                <v-icon color="green">mdi-phone-plus-outline</v-icon>
            </v-btn>
        </router-link>
        <router-link style="text-decoration: none" to="/ListarMail">
            <v-btn fab small light @click="filtrarMail">
                <v-icon color="indigo">mdi-email-plus-outline</v-icon>
            </v-btn>
        </router-link>
    </v-speed-dial>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
export default {
    components: {
    },
    data: () => ({
        fab: false,

    }),
    methods: {
        ...mapActions('common', ['getTipoContactoFiltro']),

        filtrarMail() {
            this.getTipoContactoFiltro(this.email.map(e => e.destipcontacto))
        },
        filtrarTelefono() {
            this.getTipoContactoFiltro(this.telefono.map(e => e.destipcontacto))
        },
        filtrarDomicilios() {
            this.getTipoContactoFiltro(this.domicilio.map(e => e.destipcontacto))
        }
    },
    computed: {
        ...mapGetters(['email', 'domicilio', 'telefono'])
    }

}
</script>